<template>
  <div class="shouye">
    <h1>欢迎使用自造窗后台管理系统！</h1>
    <h2>Welcome to use  WinDoor Craft system!</h2>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.shouye{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 100px;
  text-align: center
}
h1{
  font-size: 30px;
}
h2{
  color: grey
}
</style>